import { PortalRenderer } from '@/components/PortalRenderer';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { useConfigStore } from '@/store/ConfigStore';
import { useSearchStore } from '@/store/SearchStore';

export const RouteComparison = () => {
  const portalSelector = useConfigStore((state) => state.portals?.['route-comparison']);

  return (
    <PortalRenderer portalSelector={portalSelector}>
      <RouteComparisonInternal />
    </PortalRenderer>
  );
};

const RouteComparisonInternal = () => {
  const { directions, locationStart, locationEnd, locationSearch, searching, selectedRoute } = useSearchStore();

  if (!directions || !locationStart || !locationEnd || locationSearch || searching || selectedRoute) return null;

  const { routes } = directions;

  return (
    <div>
      <h2 className="mb-4 text-xl font-bold">Route comparison</h2>
      <Table className="tabular-nums">
        <TableHeader>
          <TableRow>
            <TableHead className="pl-0">Route</TableHead>
            <TableHead>NO2 (µg h/m3)</TableHead>
            <TableHead>PM2.5 (µg h/m3)</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {routes.map((route, index) => (
            <TableRow key={index} className="text-base">
              <TableCell className="pl-0 font-medium">{route.airQuality?.label_ranking}</TableCell>
              <TableCell>
                {route.airQuality?.in_modelled_area === 'Y' && route.airQuality.no2 !== null ? (
                  <>
                    {route.airQuality.no2.toFixed(1)}{' '}
                    {index !== routes.length - 1 && route.airQuality.percentage_bellow_highest?.no2 !== null && (
                      <span className="font-extralight">({route.airQuality.percentage_bellow_highest?.no2}%)</span>
                    )}
                  </>
                ) : (
                  '-'
                )}
              </TableCell>
              <TableCell>
                {route.airQuality?.in_modelled_area === 'Y' && route.airQuality['pm2.5'] !== null ? (
                  <>
                    {route.airQuality['pm2.5'].toFixed(1)}{' '}
                    {index !== routes.length - 1 && route.airQuality.percentage_bellow_highest?.pm2_5 !== null && (
                      <span className="font-extralight">
                        ({Number(route.airQuality.percentage_bellow_highest?.pm2_5) > 0 ? '+' : ''}
                        {route.airQuality.percentage_bellow_highest?.pm2_5}%)
                      </span>
                    )}
                  </>
                ) : (
                  '-'
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
